module.exports = {
          srcSet: __webpack_public_path__ + "8805f5f6f35addd73d02ac7eb02e98a0-700.png"+" 700w",
          images:[ {path: __webpack_public_path__ + "8805f5f6f35addd73d02ac7eb02e98a0-700.png",width: 700,height: 394}],
          src: __webpack_public_path__ + "8805f5f6f35addd73d02ac7eb02e98a0-700.png",
          toString:function(){return __webpack_public_path__ + "8805f5f6f35addd73d02ac7eb02e98a0-700.png"},
          
          width: 700,
          height: 394
        }